import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { cn } from "@/lib/utils";

function Progress({
  className,
  value,
  max = 100,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      className={cn(
        "relative h-3 w-full overflow-hidden rounded-full bg-slate-3 dark:bg-slatedark-3",
        className,
      )}
      {...props}
      max={max}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          "h-full w-full flex-1 bg-slate-10",
          typeof value === "number" && value >= max
            ? "bg-green-8 dark:bg-greendark-8 transition-all"
            : "bg-slate-10 dark:bg-slatedark-10 transition-all",
        )}
        style={{
          transform: `translateX(-${100 - ((value || 0) / max) * 100}%)`,
        }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
